import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AdminShellComponent } from './admin-shell/admin-shell.component';

@NgModule({
  declarations: [AdminShellComponent],
  imports: [CommonModule, RouterModule],
  exports: [AdminShellComponent],
})
export class LayoutModule {}
